var Scinet = Scinet || {};

$(function () {

    var userInfoUrl = $("[data-user-info-url]").data("user-info-url");
    if (userInfoUrl) {

        // https://www.html5rocks.com/en/tutorials/cors/
        $.ajax({
            type: "GET",
            url: userInfoUrl,
            xhrFields: {
                withCredentials: true
            },

            success: function(result) {
                if (result) {
                    var msg = result.message;
                    if (msg) {
                        Scinet.showHeaderMessage(msg);
                    }
                }
            }
        });
    }

    var userInfoMessage = $("[data-user-info-message]").data("user-info-message");
    if (userInfoMessage) {
        Scinet.showHeaderMessage(userInfoMessage);
    }

});

Scinet.getHeaderMessageHtml = function(msg, renderUl) {
    var html = "";
    if (renderUl) {
        html += "<ul id='user-info-message' class='visible-xs role-menu'>";
    }

    html += "\
        <li>\
            <a class='user-menu-message'>\
              <i class='inline-icon attention-icon-grey'></i>\
              <span class='inline-element'>" + msg + "</span>\
            </a>\
        </li>";
    if (renderUl) {
        html += "</ul>";
    }
    return html;
};

Scinet.showHeaderMessage = function(msg) {
    if (document.getElementById("user-info-message")) {
        return;
    }

    var html = Scinet.getHeaderMessageHtml(msg, true);
    $("#header-row").prepend(html);
    html = Scinet.getHeaderMessageHtml(msg, false);
    $("#user-menu").before(html);
};
